import { inject, Injectable } from "@angular/core";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/ngx-material-components/typeahead";
import { NiceAsyncTypeaheadResourceProvider } from "@recursyve/ngx-material-components/typeahead";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../../../../api/local-144/api.service";
import { findAllAccounts } from "../../../../api/local-144/fn/accounts/find-all-accounts";
import { getAccountById } from "../../../../api/local-144/fn/accounts/get-account-by-id";
import { Accounts } from "../../../../api/local-144/models/accounts";

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in
@Injectable()
export class AccountsTypeaheadResources extends NiceAsyncTypeaheadResourceProvider<Accounts> {
    private readonly api = inject(ApiService);

    public override readonly resource = "accounts";

    private readonly pageSize = 10;

    public override getById(id: number): Observable<Accounts> {
        return this.api.invoke(getAccountById, { id });
    }

    public override search(searchQuery: string, page: number): Observable<NiceAsyncTypeaheadSearchResult<Accounts>> {
        return this.api.invoke(findAllAccounts, { page, searchQuery }).pipe(
            map((accounts) => ({
                items: accounts,
                nextPage: accounts.length < this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(account: Accounts): string {
        if (!isPropertyDefined(account, "email")) {
            return "";
        }

        return account.email;
    }
}
